'use client';

import { createContext, useContext } from 'react';
import {
  ICompaniesAllState,
  IRatingAgenciesState,
  ITopRatingAgenciesState,
  ITopUnderwritersState,
  IUnderwritersState,
} from '@/creditflowresearch/application/League/interfaces';
import useLeagueTable from '@/creditflowresearch/application/League/Table/useLeagueTable';

type LeagueTableContextType = ReturnType<typeof useLeagueTable>;

export const LeagueTableContext = createContext<LeagueTableContextType>(null);

export const useLeagueTableContext = () => {
  const context = useContext(LeagueTableContext);

  if (!context) {
    throw new Error('useLeagueTableContext must be used within the LeagueTableContext');
  }

  return context;
};

interface IProps {
  topUnderwritersInitialState: ITopUnderwritersState,
  topRatingAgenciesInitialState: ITopRatingAgenciesState,
  underwritersInitialState: IUnderwritersState,
  ratingAgenciesInitialState: IRatingAgenciesState,
  companiesAllInitialState: ICompaniesAllState,
  children: React.ReactNode,
}

const LeagueTableContextProvider = ({
  topUnderwritersInitialState,
  topRatingAgenciesInitialState,
  underwritersInitialState,
  ratingAgenciesInitialState,
  companiesAllInitialState,
  children,
}:IProps) => (
  <LeagueTableContext.Provider
    value={ useLeagueTable({
      topUnderwritersInitialState,
      topRatingAgenciesInitialState,
      underwritersInitialState,
      ratingAgenciesInitialState,
      companiesAllInitialState,
    }) }
  >
    { children }
  </LeagueTableContext.Provider>
);

export default LeagueTableContextProvider;
